import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FaHotel, FaRegBell } from 'react-icons/fa';
import { VscInfo } from 'react-icons/vsc';
import { Button } from 'components/common/button';
import { BookButton } from 'components/bookButton';
import { Switch } from 'components/common/switch';

import { Dropdown } from 'components/common/dropdown';
import { MultipropertyCard } from 'components/multipropertyCard';
import { SkeletonMultipropertyCard } from 'components/skeletonMultipropertyCard';

import { getBookingWidgetMultipropertyData } from 'features/multiproperty/MultipropertySlice';
import {
    setSortByProperty,
    setIsMultipropertyTrackPrices,
} from 'features/userSlice';
import { Skeleton } from 'components/common/skeleton';
import { NoResults } from 'components/common/noResults';
import './Multiproperty.css';
import { closeModal, openModal } from 'features/modalSlice';

import { MultipropertyFilters } from 'components/multipropertyFilters';
import { useScrollToTop } from 'hooks';

const Multiproperty = ({ openPropertyDetails, showMap, enableMap }) => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const multipropertyUrl = useSelector(
        (state) => state.miniBookingWidget?.data?.multipropertyUrl
    );
    const multipropertyPropeties =
        useSelector((state) => state.multiproperty.multipropertyProperties) ||
        [];

    const filteredProperties = useSelector(
        (state) => state.multiproperty.filteredProperties
    );
    // TODO: CHANGE THIS
    const isFetchingPrices = useSelector(
        (state) => state?.miniBookingWidget?.isFetching
    );
    const isFetchingProperties =
        useSelector((state) => state.multiproperty?.isFetching) ||
        isFetchingPrices;

    const data = useSelector((state) => state.miniBookingWidget?.data);
    const multipropertyDropdown = useSelector(
        (state) => state.multiproperty?.multipropertyDropdown
    );
    const sortByOptions = multipropertyDropdown;
    const sortByText = data?.bigPlugin?.sortByText;

    const { isTrackPricesModalOpen } = useSelector((state) => state.modal);

    const ref = useScrollToTop([isFetchingPrices]);

    const multipropertyCount =
        filteredProperties !== null
            ? filteredProperties.length
            : multipropertyPropeties?.length || 0;

    const openTrackPricesModal = useCallback(() => {
        if (!isTrackPricesModalOpen) {
            dispatch(
                openModal({
                    modalId: 'TrackPricesModal',
                })
            );
            dispatch(
                setIsMultipropertyTrackPrices({
                    isMultipropertyTrackPrices: true,
                })
            );
        } else {
            dispatch(
                closeModal({
                    modalId: 'TrackPricesModal',
                })
            );
            dispatch(
                setIsMultipropertyTrackPrices({
                    isMultipropertyTrackPrices: false,
                })
            );
        }
    }, [dispatch, isTrackPricesModalOpen]);

    return (
        <div className="ab-body">
            <div className="ab-body-sidebar">
                <div className="ab-body-sidebar-inner">
                    <div className="ab-body-sidebar-alert">
                        {enableMap &&
                            (isFetchingPrices ? (
                                <Skeleton width="100%" height={85} mb={25} />
                            ) : (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '85px',
                                        backgroundImage:
                                            // 'url(https://www.xda-developers.com/files/2019/09/Screenshot_20190903-163525_Maps.jpg)',
                                            'url(https://content.r9cdn.net/res/images/horizon/ui/filters/map.svg?v=67ed7705178ef2ebdb3d1529519b8bda4fce9372&cluster=5)',
                                        backgroundPosition: '100%',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '25px',
                                        display: 'flex',
                                    }}
                                >
                                    <BookButton
                                        as="button"
                                        variant="non-member"
                                        text={Lang?.showMap}
                                        className="ab-multiproperty-nomarginup"
                                        noPrice
                                        onClick={showMap}
                                    />
                                </div>
                            ))}

                        {!isFetchingPrices ? (
                            <>
                                <div className="ab-section-alertheader">
                                    <span
                                        height="17"
                                        cleanup=""
                                        className="svg"
                                    >
                                        <FaRegBell size={14} />
                                    </span>
                                    {data?.bigPlugin?.priceAlertText}
                                </div>
                                <div className="ab-section-body">
                                    <div>
                                        <div className="ab-textAndTooltip">
                                            <span>
                                                {
                                                    data?.bigPlugin
                                                        ?.checkPriceText
                                                }
                                            </span>

                                            <Button
                                                className="ab-btn-info--room-details svg"
                                                icon={
                                                    <VscInfo
                                                        style={{
                                                            lineHeight:
                                                                'inherit',
                                                            color: 'inherit',
                                                            marginTop: '0px',
                                                        }}
                                                        size={17}
                                                    />
                                                }
                                            />
                                        </div>

                                        <Switch
                                            checked={isTrackPricesModalOpen}
                                            onChange={openTrackPricesModal}
                                            id="ab-track-prices-switch"
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <Skeleton width={'100%'} height={70} />
                        )}
                    </div>

                    <MultipropertyFilters />
                </div>
            </div>

            <div className="ab-body-main-multiproperty">
                {/* TODO: CHANGE THIS */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {isFetchingProperties ? (
                        <div className="ab-multiproperty-count">
                            <Skeleton
                                width={'65%'}
                                height={21}
                                mb={18}
                                mt={18}
                            />
                        </div>
                    ) : (
                        <div className="ab-multiproperty-count">
                            {multipropertyCount} {Lang?.propertiesFound}
                        </div>
                    )}
                    <div className="ab-inner-filters-row">
                        {isFetchingProperties ? (
                            <Skeleton
                                width={'40%'}
                                height={18}
                                mb={18}
                                mt={18}
                            />
                        ) : (
                            <div>
                                <Dropdown
                                    label={sortByText}
                                    onChange={(option) => {
                                        // TODO: NOT SURE ABOUT THIS
                                        dispatch(
                                            setSortByProperty({
                                                sortByProperty:
                                                    option.dropdownValue,
                                            })
                                        );
                                        dispatch(
                                            getBookingWidgetMultipropertyData({
                                                multipropertyUrl,
                                                sortByProperty:
                                                    option.dropdownValue,
                                            })
                                        );
                                    }}
                                    options={sortByOptions || []}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* <div className={checkPropetyClass}> */}
                <div
                    className="ab-properties-container ab-no-float ab-custom-scrollbar"
                    ref={ref}
                >
                    {isFetchingProperties && (
                        <>
                            <SkeletonMultipropertyCard />
                            <SkeletonMultipropertyCard />
                            <SkeletonMultipropertyCard />
                        </>
                    )}
                    {!isFetchingProperties &&
                        (filteredProperties !== null
                            ? filteredProperties
                            : multipropertyPropeties
                        ).map((property, index) => {
                            return (
                                <MultipropertyCard
                                    key={index}
                                    Lang={Lang}
                                    property={property}
                                    index={index}
                                    openPropertyDetails={openPropertyDetails}
                                />
                            );
                        })}

                    {!isFetchingProperties && multipropertyCount === 0 && (
                        <NoResults
                            icon={<FaHotel size={50} />}
                            message={Lang?.noPropertiesFound}
                        />
                    )}
                    <div className="ab-multiproperty-rates-text">
                        * {Lang?.multipropertyRatesText}
                    </div>
                </div>
            </div>
        </div>
    );
};

Multiproperty.propTypes = {
    enableMap: PropTypes.bool,
    openPropertyDetails: PropTypes.func,
    showMap: PropTypes.func,
};

export default Multiproperty;
